import { gsap } from 'gsap';
import { lg } from '../common';
import { disableScroll, enableScroll } from '../lib/scroll';

function initFooterMenu(footer) {
  const hamburger = footer.querySelector('.footer__hamburger');
  hamburger.setAttribute('aria-expanded', 'false');

  const open = () => {
    footer.classList.add('footer--is-menu-open');
    hamburger.setAttribute('aria-expanded', 'true');
    disableScroll();
  };
  const close = () => {
    footer.classList.remove('footer--is-menu-open');
    hamburger.setAttribute('aria-expanded', 'false');
    enableScroll();
  };
  const toggle = () =>
    footer.classList.contains('footer--is-menu-open') ? close() : open();

  hamburger.addEventListener('click', toggle);

  gsap.matchMedia().add(`(min-width: ${lg}px)`, () => {
    close();
  });

  const menuTitles = footer.querySelectorAll('button.footer__menu-link');
  menuTitles.forEach((title) => {
    title.setAttribute('aria-expanded', 'false');
    title.addEventListener('click', (e) => {
      if (window.innerWidth < lg) {
        e.preventDefault();
        const isExpanded = title.getAttribute('aria-expanded') === 'true';
        title.setAttribute('aria-expanded', !isExpanded ? 'true' : 'false');
      }
    });
  });
}

export function initFooter() {
  const footer = document.querySelector('.footer');
  if (!footer) return;

  initFooterMenu(footer);
}
